export default {
    backendurl: process.env.VUE_APP_BACKEND_URL,
    deeplinkurl: process.env.VUE_APP_DEEP_LINK,
}